import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SearchPage.module.css';

/**
 * Search listing API error and invalid dates filter messages shared by map and grid variants.
 * Quiet small text, not headings -- a failed search shouldn't shout.
 *
 * @param {Object} props
 * @param {boolean} [props.searchListingsError] - Truthy when search failed
 * @param {boolean} props.isValidDatesFilter - False when URL dates conflict with selected filter
 * @returns {JSX.Element}
 */
const SearchErrors = ({ searchListingsError, isValidDatesFilter }) => (
  <>
    {searchListingsError ? (
      <p className={css.errorText}>
        <FormattedMessage id="SearchPage.searchError" />
      </p>
    ) : null}
    {!isValidDatesFilter ? (
      <p className={css.errorText}>
        <FormattedMessage id="SearchPage.invalidDatesFilter" />
      </p>
    ) : null}
  </>
);

export default SearchErrors;
